module.exports = __webpack_public_path__ + "img/hr-level2addon_dead.0664c90a.png";